import { objectMap } from './object-methods'

function objectsValueToString<T extends string>(
  obj: Partial<Record<T, any>>,
  props?: { separator?: string; objectFieldName?: string },
): Record<T, string> {
  return objectMap(obj, (value) => {
    if (Array.isArray(value)) {
      const values: string[] = []
      value.map((item) => {
        if (typeof item === 'object' && Object.hasOwn(item, props?.objectFieldName || '')) {
          const value = item[props?.objectFieldName || '']
          values.push(value)
        } else {
          values.push(item)
        }
      })

      return values.join(props?.separator || ',')
    } else {
      return value
    }
  }) as Record<T, string>
}

const pipes = {
  objectsValueToString,
}

export default pipes
